import Poi from "./PoiRead";

export default Poi;
